import Row from '@components/row'
import styled from '@emotion/styled'
import { Form } from 'formik'

// ===== Responsive Row =====
export const ResponsiveRow = styled(Row)`
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
`

// ===== Left Column =====
export const LeftColumn = styled.div`
  flex: 2;
  min-width: 280px;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
    margin-bottom: 10px;
  }
`

// ===== Right Column =====
export const RightColumn = styled.div`
  flex: 1;
  min-width: 250px;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
`

// ===== Form Container =====
export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 15px;

  padding: 20px;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 15px;
    gap: 12px;
  }

  // Make all input wrappers full width on mobile
  input,
  select,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }

  // Buttons inside form
  button {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`

// ===== Button Container =====
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  @media (max-width: 768px) {
    justify-content: center;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`
